import { FormFieldTaxInfo } from './form-field-tax-info.model';
import { RevenueArcInfo } from './revenue-arc-info.model';

export class FormFieldRevenueInfo {
  //#region Properties
  public RevenueItemNum: number;
  public Formula: string;
  public Price: number;
  public TaxInfo: Array<FormFieldTaxInfo>;
  public UseArc: boolean;
  public ArcInfo: RevenueArcInfo;
  public IsProrated: boolean;
  public ProrationMonth: number; // 0-indexed

  //#endregion

  public constructor() {
    this.RevenueItemNum = 0;
    this.Formula = '';
    this.Price = 0;
    this.TaxInfo = new Array<FormFieldTaxInfo>();
    this.UseArc = false;
    this.ArcInfo = new RevenueArcInfo();
    this.IsProrated = false;
  }
}
